module.exports = "/images/generic.svg?3329f94438c68ec15fb3f4bcd6ace412";